import { __extends } from "tslib";
import { createElement, Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { Microfrontend, } from '@descomplica/microfrontend-core';
var Translator = /** @class */ (function () {
    function Translator() {
    }
    Translator.prototype.exposeMicrofrontend = function (reactComponent, microfrontendOptions) {
        var _this = this;
        var microfrontendFactory = new Microfrontend({
            microfrontendOptions: microfrontendOptions,
            mount: function (rootElement, props) {
                _this.Component = createElement(reactComponent, props);
                ReactDOM.render(_this.Component, rootElement);
            },
            unmount: function (rootElement) {
                ReactDOM.unmountComponentAtNode(rootElement);
            },
        });
        return microfrontendFactory;
    };
    Translator.prototype.createMicrofrontend = function (microfrontend) {
        var Comp = /** @class */ (function (_super) {
            __extends(Comp, _super);
            function Comp(props) {
                var _this = _super.call(this, props) || this;
                _this.ref = createRef();
                return _this;
            }
            Comp.prototype.componentDidMount = function () {
                microfrontend.mount(this.ref.current, this.props);
            };
            Comp.prototype.componentWillUnmount = function () {
                microfrontend.unmount(this.ref.current);
            };
            Comp.prototype.render = function () {
                return createElement('div', { ref: this.ref });
            };
            return Comp;
        }(Component));
        return Comp;
    };
    return Translator;
}());
export var translator = new Translator();
